export interface UserInfo {
  firstname: string;
  lastname: string;
  username: string;
  email?: string;
  picture?: string;
  roles: string[];
}

let myinfo: UserInfo = {
  firstname: "",
  lastname: "",
  username: "",
  email: "",
  picture: "",
  roles: [],
};

const firstString = (...values: any[]) =>
  values.find((v) => typeof v === "string" && v.trim().length > 0)?.trim() || "";

const arrayOfStrings = (value: any): string[] => {
  if (!Array.isArray(value)) {
    return [];
  }

  return value.filter((v) => typeof v === "string");
};

export const userInfoFromSession = (session: any): UserInfo => {
  const source = session?.user || session?.principal || session || {};

  const fullName = firstString(
    source.name,
    source.displayName,
    source.fullName,
    session?.name,
    session?.displayName
  );

  const splitName = fullName.split(/\s+/).filter(Boolean);

  const firstname = firstString(
    source.firstname,
    source.firstName,
    source.given_name,
    source.givenName,
    session?.firstname,
    session?.firstName,
    session?.given_name,
    splitName[0]
  );

  const lastname = firstString(
    source.lastname,
    source.lastName,
    source.family_name,
    source.familyName,
    session?.lastname,
    session?.lastName,
    session?.family_name,
    splitName.length > 1 ? splitName.slice(1).join(" ") : ""
  );

  const username = firstString(
    source.username,
    source.preferred_username,
    source.login,
    source.sub,
    source.email,
    session?.username,
    session?.preferred_username,
    session?.sub,
    session?.email
  );

  const email = firstString(
    source.email,
    session?.email
  );

  const picture = firstString(
    source.picture,
    source.avatar,
    source.image,
    session?.picture,
    session?.avatar,
    session?.image
  );

  const roles = [
    ...arrayOfStrings(source.roles),
    ...arrayOfStrings(source.authorities),
    ...arrayOfStrings(session?.roles),
    ...arrayOfStrings(session?.authorities),
  ];

  return {
    firstname,
    lastname,
    username,
    email,
    picture,
    roles: Array.from(new Set(roles)),
  };
};

export const setUserInfoFromSession = (session: any): UserInfo => {
  myinfo = userInfoFromSession(session);
  return myinfo;
};

export const getUserInfo = () => myinfo;

export const hasRole = (role: string) => myinfo.roles.includes(role);